<div class="escalation-confirmation-dialog">
  <h2 mat-dialog-title class="dialog-title">
    <mat-icon class="title-warning-icon">warning</mat-icon>
    {{ title }}
  </h2>

  <mat-dialog-content class="dialog-content">
    <p class="confirmation-message">{{ message }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button
      mat-flat-button
      class="cancel-button mm-bg-gray mm-text-dark mm-mr-2"
      (click)="onCancel()"
      type="button"
    >
      {{ cancelButtonText }}
    </button>
    <button
      mat-flat-button
      class="confirm-button mm-bg-red mm-text-white mm-mr-2"
      (click)="onConfirm()"
      type="button"
    >
      {{ confirmButtonText }}
    </button>
    @if (showStandardAchievedButton) {
    <button
      mat-flat-button
      class="standard-achieved-button mm-bg-green mm-text-white"
      (click)="onStandardAchieved()"
      type="button"
      cdkFocusInitial
    >
      {{ standardAchievedButtonText }}
    </button>
    }
  </mat-dialog-actions>
</div>
